import { withPlugins, domEvents, device } from '@spon/plugins';

import toggle from '@/ui/toggle';

function FilterTray({ node, name, plugins: { addEvents, device } }) {
	if (!node) return;

	let windowXWidth = window.innerWidth;

	const breakpoint = 768;
	const header = document.getElementById('header');
	const parent = document.getElementById('AlgoliaResultsContainer');
	const results = document.getElementById('AlgoliaResults');

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);
		},
	};

	const filters = toggle({
		button: node.querySelector('#FiltersButton'),
		name,
		activeClass: 'is-active',
	});
	filters.init();

	// function clickWhenTrayOpenHandle({ target }) {
	function onClick({ target }) {
		if (target.classList.contains('o-close') && filters.isOpen) {
			filters.close();
		}
	}

	filters.on(`open:${name}`, ({ target }) => {
		// node.classList.add('is-open');
		target.classList.add('is-open');
		// window.scroll(0, target.getBoundingClientRect().top + scrollY);
		results.classList.add('is-open');
		if (window.innerWidth < breakpoint) {
			header.style.zIndex = 29;
			lock.capture();
		}

		let scale = 0;
		if (window.innerWidth >= 1280) {
			scale = 0.75;
		} else if (window.innerWidth >= 768) {
			scale = 0.6666;
		}

		if (scale) {
			parent.style.height = `${results.offsetHeight * scale}px`;
		}
	});

	filters.on(`close:${name}`, ({ target }) => {
		// node.classList.remove('is-open');
		target.classList.remove('is-open');
		results.classList.remove('is-open');

		// if (window.innerWidth < breakpoint) {
		header.style.zIndex = 50;
		lock.release();
		// }

		parent.style.height = '';
	});

	function onKeyDown(event) {
		const { code } = event;

		if (code === 'Escape') {
			if (filters.isOpen) filters.close();
		}
	}

	addEvents(document.body, {
		click: onClick,
		keydown: onKeyDown,
	});

	/*
	 *		Resizing
	 */
	device.resize(() => {
		// Check if we're resizing X... as Y will trigger from device address bar show&hide
		if (windowXWidth !== window.innerWidth) {
			windowXWidth = window.innerWidth;
			lock.release();

			if (window.innerWidth < breakpoint && filters.isOpen) {
				header.style.zIndex = 29;
			}
		}
	});
}

export default withPlugins(domEvents, device)(FilterTray);
